import React, { FC } from "react";
import { Image } from "../image";
import type { CentralBanksExpandRegularEntitiesProps } from "@/types";
import { TextCols } from "../text-cols";

export const CentraBanksExpandRegularEntities: FC<
  CentralBanksExpandRegularEntitiesProps
> = ({ content, cover }) => {
  return (
    <section className="centralBanksExpandRegularEntities">
      <div className="wrapper">
        <TextCols content={content} maxTitleWidth={700} />
      </div>
      <div className="wrapper wrapper_lg">
        {cover.file?.url && (
          <Image
            className="centralBanksExpandRegularEntities--cover"
            src={cover as any}
            alt={cover.title}
            animateInView
          />
        )}
      </div>
    </section>
  );
};
